module.exports = __webpack_public_path__ + "static/media/TuuliUtrainien.251cd7dd.png";